import EventsCenter from '@Managers/Events/EventsCenter';
import { ALL_EVENTS_LIST } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

export default class SymbolSoundsManager {
    private readonly shortAnimSoundCountBySymbolId = new Map<number, number>();

    constructor() {
        Logger.log(LoggerLevel.Constructor, {
            class: 'SymbolSoundsManager',
            message: 'SymbolSoundsManager constructor',
            source: LoggerSource.Game
        });
        this.init();
    }

    init(): void {
        EventsCenter.on(ALL_EVENTS_LIST.SPIN_STATE, this.onSpinStart, this);
    }

    public getNextShortAnimSoundCount(symbolId: number): number {
        const currentCount = this.shortAnimSoundCountBySymbolId.get(symbolId) ?? 0;
        const nextCount = currentCount + 1;

        this.shortAnimSoundCountBySymbolId.set(symbolId, nextCount);

        return nextCount;
    }

    private onSpinStart(): void {
        this.shortAnimSoundCountBySymbolId.clear();
    }
}
